import styled from 'styled-components';
import { COLORS, FONTS } from 'utils/constants/styles';

const StyledText = styled.span`
    font-weight: ${FONTS.BOLD};
    text-transform: uppercase;
    color: ${props => props.theme.background.revertTheme || COLORS.BUTTON_BACKGROUND};
`;

type Props = {
    children: string;
};

const BoldPinkUppercasedText = ({ children }: Props) => <StyledText>{children}</StyledText>;

export default BoldPinkUppercasedText;
